export default __webpack_public_path__ + "static/media/Fuji.113f2df2.png";